import { useEffect, useContext } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { CSPUrlsMap } from '../../../routes/CSPUrlsMap';
import { BrandContext } from '../../../contextProviders/brandContext';
import { AUTHENTICATION_TYPES } from '../../../constants/constants';
import { clearKnownPii } from '../../../services/gtmService/piiRegistry';

export const Logout = () => {
  const { authenticationType, ssoLoginUrl } =
    useContext(BrandContext).activeBrandContext.cspConfiguration.auth0Config[process.env.REACT_APP_ENV];

  const { logout } = useAuth0();
  const loginUrl = `${window.location.origin}${CSPUrlsMap.login.url}`;

  useEffect(() => {
    sessionStorage.clear();
    localStorage.clear();
    clearKnownPii();
    if (authenticationType === AUTHENTICATION_TYPES.SSO) {
      // For SSO, redirect to home page or login page after clearing session storage
      logout({
        logoutParams: {
          federated: true,
          returnTo: ssoLoginUrl
        }
      });
    } else {
      // For non-SSO, redirect to Auth0 logout endpoint to clear the session
      logout({
        logoutParams: { returnTo: loginUrl }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logout, loginUrl]);

  return null;
};
